export const exerciseBlockContent = {
    en: {
        break: "Break",
        completed: "Completed",
        to_complete: "Mark as Done",
        checked: "Checked",
        comm_mistakes: "Common mistakes:",
        no_data: "NO DATA.",
        work: "Work",
        rest: "Rest",
        m_map: "Miscle map",
        muscles: "Muscles:",
        description: "Description:",
        stopped: "STOPPED",
        set: "Set ",
        tap_to: "Tap to: ",
        pause: "pause",
        start: "start",
    },
    sl: {
        break: "Odmor",
        completed: "Zaključeno",
        to_complete: "Označi kot opravljeno",
        checked: "Checked",
        comm_mistakes: "Pogoste napake:",
        no_data: "NI PODATKOV.",
        work: "Delaj",
        rest: "Počivaj",
        m_map: "Slika aktiviranih mišic",
        muscles: "Mišice:",
        description: "Opis vaje:",
        stopped: "USTAVLJENO",
        set: "Set: ",
        tap_to: "Klikni za: ",
        pause: "pavzo",
        start: "začni",
    },
} as const;